module.exports = __webpack_public_path__ + "static/media/close_white.e9d0a30d.svg";